
import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import SimpleTablePage from '../../../containers/commons/general/SimpleTablePage'
import { handleKeyDown } from '../../../util/utils'

class PwkTypeMasterModal extends PureComponent {
  submitPwkType (values) {
    if (this.props.pwkTypeId) {
      this.props.actions.updatePaperwokTypeMaster(values, this.props.languageList, this.props.pwkTypeId)
    } else {
      this.props.actions.postPwkTypeMasterModal(values, this.props.languageList)
    }
  }

  render () {
    const {
      t, handleSubmit, languageList = [],
      showModal
    } = this.props
    const tKey = 'MASTERS.PWK_TYPES_MASTER.MODAL.'
    return (
      <Modal id="pwkTypeMasterModal" className="_nf" show={showModal} onHide={this.props.actions.adviceClosePaperwokTypeMasterModal} backdrop={'static'}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitPwkType.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.adviceClosePaperwokTypeMasterModal}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <SimpleTablePage
              // customClass={'langTable'}
              columns={[
                <th className='colWidth-15 alignC' key={2}>
                  {t('MASTERS.LANGUAGE')}
                </th>,
                <th className='colWidth-30' key={0}>
                  {t('MASTERS.NAME')}
                </th>,
                <th className='colWidth-55' key={1}>
                  {t('MASTERS.DESCRIPTION')}
                </th>
              ]}
              rows={languageList && languageList.map((val, idx) => (
                <tr key={idx}>
                  <td className='alignC'>
                    <p><span>{`${val.description}`}</span></p>
                    <p>{`(${val.name})`}</p>
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.name`}
                      placeholder={t('MASTERS.NAME')}
                      maxLength={50}
                    />
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.description`}
                      placeholder={t('MASTERS.DESCRIPTION')}
                      maxLength={100}
                    />
                  </td>
                </tr>
              ))}
            />
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}
const validate = (values, props) => {
  const errors = {}
  props.languageList.map(language => {
    errors[`lang${language.languageId}`] = {}
    if (values[`lang${language.languageId}`]) {
      if (!(values[`lang${language.languageId}`].name) || values[`lang${language.languageId}`].name.length === 0) {
        errors[`lang${language.languageId}`].name = props.t('MASTERS.VALIDATION.NAME_REQUIRED')
      }
      if (!(values[`lang${language.languageId}`].description) || values[`lang${language.languageId}`].description.length === 0) {
        errors[`lang${language.languageId}`].description = props.t('MASTERS.VALIDATION.DESCRIPTION_REQUIRED')
      }
    } else {
      errors[`lang${language.languageId}`].name = props.t('MASTERS.VALIDATION.NAME_REQUIRED')
      errors[`lang${language.languageId}`].description = props.t('MASTERS.VALIDATION.DESCRIPTION_REQUIRED')
    }
  })
  return errors
}

export default reduxForm({
  form: 'editPwkTypeModal',
  validate
})(PwkTypeMasterModal)
